/* Anchor the search dialog near the top of the viewport rather than
 * vertically centered. Without overriding the base dialog's enter
 * keyframe, the 200ms entrance animation tweens via the centered
 * `translate(-50%, -50%)` transform and only snaps to the override
 * `translateX(-50%)` once the animation ends — producing a vertical
 * jank as the dialog drops into place. The keyframe below matches the
 * steady-state transform so the entrance is smooth from frame one. */
@keyframes searchDialogEnter {
  from {
    opacity: 0;
    transform: translateX(-50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) scale(1);
  }
}

/* Desktop (#2555): 640 px, near the top */
.dialog {
  top: 32px;
  inline-size: 640px;
  max-inline-size: calc(100vw - 32px);
  padding: 0;
  margin: 0;
  overflow: hidden;
  transform: translateX(-50%);
  animation: searchDialogEnter 200ms ease-out;
}

/* Phone (screen F): full screen, so the results stay above the keyboard */
.dialog.phone {
  /* Pinned to every edge: the desktop rule's `left: 50%` and centring transform must not apply */
  inset: 0;
  inline-size: 100%;
  max-inline-size: none;
  display: flex;
  flex-direction: column;
  transform: none;
  animation: none;
}
